<!-- layouts/MainLayout -->
<template>
	<div class="main-layout">
		<!-- 公共头部 -->
		<ComHeader />
		<!-- 路由出口：页面主体内容会渲染在这里 -->
		<router-view />
		<!-- 公共尾部 -->
		<ComFooter />
		<!-- 全局登录弹窗（挂载在根节点，全局显示） -->
		<GlobalLoginModal />
		<!-- ref="vipBuy" style="display: none;"  -->
		<VipBuy />
		<!-- <GlobalProvince /> -->
	</div>
</template>

<script>
	export default {
		name: 'MainLayout',
	}
</script>

<style scoped>
	.main-layout {
		width: 100%;
		min-height: 100vh;
		padding-bottom: 20px;
		background: linear-gradient(to bottom, #E9F7FF 0%, #F0F8FF 20%, #F5F6F8 50%);
	}
</style>